import { useEffect } from 'react';
import { useSparks } from '../../contexts/SparksContext';

// Long enough for the completion reply; a host that never swaps in a recap still lets go.
export const FINISH_HOLD_MAX_MS = 10000;

/**
 * Mounted on a quiz's finished screen while its host (worksheets, assignments, Core Skills homework) waits on the
 * completion reply before swapping in the recap. Holds what the recap holds — the nav pops and shop news — so the
 * "+N" or "something new to buy" from that reply does not flash up before the recap plays it in turn (the cards
 * need no hold: they only ever play once a recap releases them). The recap takes the holds over in the same commit
 * this unmounts in.
 */
export default function SparksFinishHold() {
  const { setRecapOpen, setShopNewsHeld } = useSparks();
  useEffect(() => {
    const hold = (on) => {
      setRecapOpen(on);
      setShopNewsHeld(on);
    };
    hold(true);
    const t = setTimeout(() => hold(false), FINISH_HOLD_MAX_MS);
    return () => {
      clearTimeout(t);
      hold(false);
    };
  }, [setRecapOpen, setShopNewsHeld]);
  return null;
}
